import { DeleteIcon, FaroText } from "@faro-lotv/flat-ui";
import { ListItemIcon, MenuItem } from "@mui/material";
import { JSX } from "react";

type DeleteNodeContextMenuActionItemProps = {
  /** Whether the delete action is disabled */
  disabled?: boolean;
  /** Callback function to handle the delete action */
  onDelete(): void;
};

/**
 * @returns context menu item for delete action
 */
export function DeleteNodeContextMenuActionItem({
  disabled,
  onDelete,
}: DeleteNodeContextMenuActionItemProps): JSX.Element {
  return (
    <MenuItem key="delete" onClick={onDelete} disabled={disabled}>
      <ListItemIcon>
        <DeleteIcon />
      </ListItemIcon>
      <FaroText variant="labelL">Delete</FaroText>
    </MenuItem>
  );
}
